import axios from 'axios';

const instance = axios.create({
  baseURL: window.env.VUE_APP_API_URL || process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default instance;
